import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getProcessesList } from '../../store/MRP/Processes/ProcesseSlice';

const useGetProcessesList = () => {
  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (ProcessesList?.length === 0) {
      dispatch(getProcessesList());
    }
  }, []);

  const { ProcessesList, loading, error } = useAppSelector((state) => state.MrpProcesses);

  const optionsProcesses = ProcessesList?.map((m) => ({
    value: m.id,
    label: i18n.language === 'en' ? m.name : m.name2,
  }));

  return { ProcessesList, optionsProcesses, loading, error };
};

export default useGetProcessesList;
